<template>
  <div v-if="store.contact" class="store-info">
    <div v-for="(item, index) in store.contact" :key="index" class="store">
      <div class="item">
        <h2>{{ item.name }}</h2>
        <p>{{ item.addr }}</p>
        <p>
          <a :href="'tel:' + item.mobile">
            <i class="anyteachicon anyteach-phone" />
            <span>{{ item.mobile }}</span>
          </a>
        </p>
      </div>
    </div>
  </div>
  <div v-else class="store">
    <div class="item">
      <h3>电话</h3>
      <p>
        <a :href="'tel:' + store.mobile">
          <i class="anyteachicon anyteach-phone" />
          <span>{{ store.mobile }}</span>
        </a>
      </p>
    </div>
    <div class="item">
      <h3>地址</h3>
      <p>{{ store.addr }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["store"],
}
</script>

<style lang="scss" scoped>
.store {
    * {
      user-select: text;
    }
    margin: 0 0 20px 0;
    &:last-of-type {
      margin-bottom: 5px;
    }
  .item {
    margin: 0 0 15px 0;
    h2 {
      font-size: 1rem;
      font-weight: 500;
    }
    h3 {
      font-size: 0.8rem;
      font-weight: 500;
    }
    p {
      font-size: 0.875rem;
    }
    a {
      color: $blue;
      border-bottom: 1px solid $blue;
    }
    i {
      font-size: inherit;
      margin-right: 3px;
    }
  }
}
</style>
